<template>
  <div
    class="base-swiper-item"
    :style="{
      width: $parent.offsetWidth - gap + 'px',
      height: $parent.height + 'px',
      transform: `translateX(${offsetWidth}px)`,
      transition: `transform ${delay}ms`,
      'z-index': zIndex,
    }"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "BaseSwiperItem",
  props: {
    // 如果我们希望两个轮播之间存在间隔 设置此参数而不用使用margin
    gap: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data () {
    return {
      offsetWidth: 0,
      zIndex: 1, //默认的都是1 如果是最后一个需要向前移动的时候 则是-1来实现隐藏
    }
  },
  computed: {
    delay () {
      return this.zIndex === -1 ? 0 : this.$parent.delay
    },
  },
  methods: {
    setOffset (v, isCritical) {
      this.zIndex = isCritical ? -1 : 1
      this.offsetWidth = v
    },
  },
};
</script>
<style scoped lang="scss">
.base-swiper-item {
  position: absolute;
  padding: 15px 0px;
  box-sizing: border-box;
}
</style>
